import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {
    NgbActiveModal,
    NgbModalOptions,
    NgbPopover,
    NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
    WdxButtonModule,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import {
    TranslateTokenisedStringPipe,
    UTILS_ICON_CLOSE,
    UTILS_ICON_COPY,
    UTILS_ICON_DOWNLOAD,
    WdxDestroyClass,
} from '@wdx/shared/utils';
import { saveAs } from 'file-saver';

@Component({
    selector: 'wdx-error-model',
    imports: [
        CommonModule,
        TranslateTokenisedStringPipe,
        WdxIconModule,
        WdxButtonModule,
        NgbPopoverModule,
    ],
    templateUrl: './wdx-error-modal.component.html',
    styleUrls: ['./wdx-error-modal.component.scss'],
})
export class WdxErrorModalComponent extends WdxDestroyClass {
    public activeModal = inject(NgbActiveModal);

    @Input() title!: string;
    @Input() description!: string;
    @Input() jsonData!: string;
    @Input() modalOptions!: NgbModalOptions;

    public showJson = false;
    public showErrorDetails = false;

    readonly WDX_BUTTON_STYLE = WdxButtonStyle;
    readonly ICON_COPY = UTILS_ICON_COPY;
    readonly ICON_DOWNLOAD = UTILS_ICON_DOWNLOAD;
    readonly ICON_CLOSE = UTILS_ICON_CLOSE;

    public onClose(): void {
        this.activeModal.close();
    }

    public showJsonError() {
        this.showJson = true;
        this.modalOptions.size = 'lg';
        this.activeModal.update(this.modalOptions);
    }

    public copyJson(popover: NgbPopover): void {
        const jsonString = JSON.stringify(this.jsonData, null, 2);

        navigator.clipboard.writeText(jsonString).then(() => {
            popover.open();
            setTimeout(() => {
                popover.close();
            }, 1500);
        });
    }

    public downloadJson(): void {
        const jsonString = JSON.stringify(this.jsonData, null, 2);
        const blob = new Blob([jsonString], { type: 'application/json' });
        saveAs(blob, 'error.json');
    }
}
